import { AffiliationStatus, ApplicationStatus } from '../constants/constants';

export const isAffiliationActive = (status: AffiliationStatus) =>
  [AffiliationStatus.ACTIVE, AffiliationStatus.EXPIRING_SOON].includes(status);

export const isApplicationPending = (status: ApplicationStatus) =>
  [ApplicationStatus.NEW, ApplicationStatus.IN_PROCESS, ApplicationStatus.APPLICANT_RESPONDED].includes(status);

export const isApplicationSubmitted = (status: ApplicationStatus) =>
  [ApplicationStatus.APPROVED, ApplicationStatus.NEW, ApplicationStatus.IN_PROCESS].includes(status);

// Underlying statuses are more granular than the display statuses
export const getApplicationDisplayStatus = (status: ApplicationStatus) => {
  if ([ApplicationStatus.APPLICANT_RESPONDED, ApplicationStatus.NEW].includes(status)) {
    return ApplicationStatus.NEW;
  }
  return status;
};
